/**
 * One place that decides which URL a category is linked on.
 *
 * Order matters and is about search ranking, not looks:
 *   1. landing_path  - the legacy multi-segment page, e.g.
 *                      /tours-charters-st-john-virgin-islands/private-boat-charters
 *   2. legacy_path   - the legacy single-segment page, e.g.
 *                      /booking-private-powerboat-charters-in-st-john-vi
 *   3. /<slug>        - the root level URL the legacy site used for its category pages
 *                      (e.g. /lime-out-excursions), served by the root resolver.
 * /activities/category/<slug> stays a working route, it is just never the one we link.
 *
 * Every link in the site goes through this so an indexed URL can never be bypassed, and
 * ActivityListPage sends anybody who lands on the /activities/category/... variant of a
 * category that owns a legacy URL over to that legacy URL instead.
 */
const clean = (value) => (value || '').trim().replace(/^\/+|\/+$/g, '');

export const categoryUrl = (category) => {
  if (!category) return '/activities';
  const landing = clean(category.landing_path);
  if (landing) return `/${landing}`;
  const legacy = clean(category.legacy_path);
  if (legacy) return `/${legacy}`;
  const slug = clean(category.slug);
  return slug ? `/${slug}` : '/activities';
};

/** True when the browser is not already on the category's canonical URL. */
export const needsCategoryRedirect = (category, pathname) => {
  const target = categoryUrl(category);
  if (target === '/activities') return false;
  return clean(pathname) !== clean(target);
};

export default categoryUrl;
